import React, { useState } from 'react'
import { Card, Button, Modal } from 'react-bootstrap'
import InitialPaymentDetailFill from './InitialSubscriptionModal/InitialPaymentDetailFill'
import ReactModal from 'react-modal'

type Props = {
  plan: any
  selectedCurrency: any
}

const InitialSubscriptionCard: React.FC<Props> = ({ plan, selectedCurrency }) => {
  const [isHovered, setIsHovered] = useState<boolean>(false)
  const [isInitialPaymentModalOpen, setIsInitialPaymentModalOpen] = useState<boolean>(false)

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '15px',
      border: 'none',
      boxShadow: '0 2px 8px 0 #00000029'
    }
  }

  const openInitialPaymentModal = () => {
    setIsInitialPaymentModalOpen(true)
  }

  const afterOpenPaymentModal = () => {}

  const closeInitialPaymentModal = () => {
    setIsInitialPaymentModalOpen(false)
  }

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const styleHover = {
    transform: `scale(${isHovered ? '1.025' : '1'})`,
    transition: 'transform 0.2s ease-in-out',
    boxShadow: isHovered ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none'
  }

  // Convert price to the selected currency
  const convertedPrice = plan.package.packageAmount

  // Determine currency symbol
  const currencySymbol = selectedCurrency === 'USD' ? '$' : '₹'

  // Function to format the feature keys
  const formatFeatureKey = (key: string) => {
    if (key === 'additionalChannelntegration') {
      return 'Additional Channel Integration'
    }
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .replace(/C R M/, 'CRM')
  }

  return (
    <>
      <Card
        className='bg-white p-10 rounded-lg shadow subscription-card'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={styleHover}
      >
        <h1 className='h6 text-uppercase font-weight-bold mb-4'>{plan.title}</h1>
        <h2 className='h1 font-weight-bold'>
          {currencySymbol}
          {convertedPrice}
          <span className='text-small font-weight-normal ml-2'>/Month</span>
        </h2>
        <div className='custom-separator my-4 mx-auto bg-primary'></div>
        <div className='mt-4 mb-6'>{plan?.package?.packageDescriptions}</div>
        <Button
          className='btn btn-primary p-3 shadow rounded-pill w-50 mx-auto'
          onClick={openInitialPaymentModal}
        >
          Subscribe
        </Button>
      </Card>

      {/* <Modal show={isInitialPaymentModalOpen} onHide={closeInitialPaymentModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InitialPaymentDetailFill
            closeInitialPaymentModal={closeInitialPaymentModal}
            plan={plan}
            currentPlan={[]}
          />
        </Modal.Body>
      </Modal> */}

      <ReactModal
        isOpen={isInitialPaymentModalOpen}
        onAfterOpen={afterOpenPaymentModal}
        onRequestClose={closeInitialPaymentModal}
        style={customModalStyles}
        contentLabel='Payment Fill'
      >
        <InitialPaymentDetailFill
          closeInitialPaymentModal={closeInitialPaymentModal}
          plan={plan}
          currentPlan={[]}
        />
      </ReactModal>
    </>
  )
}

export default InitialSubscriptionCard
